export default __webpack_public_path__ + "static/media/title.ffaf9f44.jpg";